<template>
	<section class="small-12 columns propertyDescription" v-if="property">
		<div class="small-12 widget border-bottom">
			<div class="small-12 widgetTitle flex vertical-align">
				<h2 class="small-12 flex vertical-align"> 
					Property Description
				</h2>
			</div>
			<div class="small-12">
				<p class="small-12" v-html="property.attributes.description" v-if="property.attributes.description"></p>
				<div class="small-12 emptyResults" v-else>
					<picture class="small-12 flex justify-center">
						<img width="120" :src="empty_image" alt="Nestd Logo in a House">
					</picture>
					<h6 class="small-12 text-center">
						Description not found
					</h6>
					<p class="small-12 text-center">
						A description for this property has not been set yet.
					</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script>

	// Import firebase
	import { propertiesModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PropertyDescription',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			property: null,
			empty_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fpage-writing-screen.svg?alt=media&token=eb566a75-e922-4ec0-9c47-0f1e5b4f6522'

		}),

		/*
        ** Do this first
        */

        mounted() {

        	// Bind to the doc
			this.$bind('property', propertiesModel.doc(this.$route.params.id));

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		 /*
		**  Set the computed props
		*/

		computed: {

			//

		}

	}

</script>